<div class="body">

    <table mat-table [dataSource]="(providerService.contacts$|async)|sortedObjectArray:active:direction:(providerService.contacts$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="contactperssalutation">
            <th mat-header-cell mat-sort-header="contactperssalutation" *matHeaderCellDef>Anrede</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contactperssalutation}}

            </td>
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="4" class="footer">
                {{(providerService.contacts$|async)?.length}} Ansprechpartner
            </td>
        </ng-container>

        <ng-container matColumnDef="contactpersfname">
            <th mat-header-cell mat-sort-header="contactpersfname" *matHeaderCellDef>Vorname</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contactpersfname}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="contactperslname">
            <th mat-header-cell mat-sort-header="contactperslname" *matHeaderCellDef>Nachname</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contactperslname}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showContact(element.value)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
